import { useDebateStore } from "../store/debateStore";

const select = (s: ReturnType<typeof useDebateStore.getState>): number =>
  s.playheadMs;

/**
 * Read the current audio playhead (ms since session start). Subscribers re-render
 * only when the playhead value changes — wired through Zustand's reference equality.
 */
export function useAudioClock(): number {
  return useDebateStore(select);
}
